import { Stack } from "@mantine/core";
import type { JSX } from "react";
import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { DetectedCues } from "@/sales-tools/detected-cues/DetectedCues";
import { useIsSalesEnabled } from "@/sales-tools/hooks/useIsSalesEnabled";
import { CustomerLocation } from "./CustomerLocation";
import { DigitalCompetency } from "./digital-competency/DigitalCompetency";

export function CustomerInsights(): JSX.Element | null {
    const { isDigitalCompetencyInsightEnabled } = usePartnerFeatureConfigured();
    const isSalesEnabled = useIsSalesEnabled();
    return (
        <Stack p="sm" pt="sm" gap="sm">
            <CustomerLocation />
            {isSalesEnabled && <DetectedCues />}
            {isDigitalCompetencyInsightEnabled && <DigitalCompetency />}
        </Stack>
    );
}
